<div class="adv-detail page-bg" [ngClass]="(isImageSet)?'with-photo':'no-photo'">
  <div class="container pb-2 pt-4">
    <div class="row">
      <div class="col-12">
        <mat-card>
          <ng-template #advContent>
            <div class="details-row row pt-5 pb-4">
              <div [className]="
                  isImageSet ? 'col-md-6 col-sm-12 p-0 pl-5' : 'col-md-12 col-sm-12 p-0'
                ">
                <mat-card class="p-0">
                  <div class="text-right" *ngIf="isUserAdmin"><a [routerLink]="['/adv-edit/', advCode]">[Edit]</a></div>
                  <h2 class="adv-title entry-title m-0">
                    {{ this.resolveAdvTitle(advParam) }}
                  </h2>
                  <span *ngIf="ageIsValid()" class="pink-text age-pos"> Age: {{ advParam?.age }}</span>
                  <mat-card-content>
                    <div style="white-space: pre-wrap" class="std-text-col">{{ advParam?.content || "" }}</div>
                    <div class="row m-0 mt-5">
                      <div class="col-6 p-0">
                        <span class="adv-location pink-text" *ngIf="Location"> {{ Location }}</span>
                      </div>
                      <div class="publish-info col-6 p-0 text-right">
                      <!-- <i class="icons-calendar-alt"></i>--><span class="adv-date">{{ dateStart }}</span>
                        <b class="adv-user-nick pink-text">{{ advParam?.userNick || "" }}</b>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="offset-md-1 col-md-4 col-sm-12 p-0" *ngIf="isImageSet">
                <mat-card class="p-0 mat-transparent-bg">
                  <ngx-gallery [images]="galleryImages"
                              [options]="galleryOptions"></ngx-gallery>
                  <!-- <mat-icon class="gallery-zoom-button">zoom_in</mat-icon> -->
                </mat-card>
              </div>
            </div>
          </ng-template>
          <ng-template [ngTemplateOutlet]="advContent" *ngIf="(isPremium && service.enableSubscription); else withAdvert"></ng-template>
          <ng-template #withAdvert>
            <div class="row">
              <div class="col-10">
                <ng-template [ngTemplateOutlet]="advContent"></ng-template>
              </div>
              <div class="col-2" [ngStyle]="{'min-height': service.advService.bannersEnabled ? '600px' : 'auto'}">
                <ng-container *ngIf="service.advService.bannersEnabled">
                  <div class="adsContainer adsContainer__vertical adsContainer__vertical--right w-100 p-0">
                    <app-banner-zone-map [zoneType]="['Desktop-Zone-Vertical-Left', 'Desktop-Zone-Vertical-Right']" ></app-banner-zone-map>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>

          <div class="row">
            <div class="col-10 p-0" *ngIf="existedConversationId == 0 && !watchingByAuthor && !(advParam.isDemo && isUserAdmin)">
              <mat-tab-group animationDuration="0ms">
                <mat-tab label="Message">
                  <conv-send-message [acceptTermsEnable]="true" [captchaEnabled]="true" [nickVisible]="true" (submitClick)="sendInitialConversationMessage($event)"></conv-send-message>
                </mat-tab>
              </mat-tab-group>
            </div>
            <div class="col-10 p-0 mt-3 mb-3 text-center" *ngIf="existedConversationId > 0" style="margin-top:10px">
              <div><strong>You have active conversation with this user!</strong></div>
              <a [routerLink]="['/conversations', existedConversationId]" [queryParams]="{page: page,perPage:perPage}" mat-flat-button color="primary">Go to conversation</a>
                <!--<button (click)="fireSubmitEvent($event)" class="submit-button p-2 pl-4 pr-4"
                        [disabled]="submitInProgress"
                        mat-flat-button color="primary" type="submit">-->
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
